module.exports = __webpack_public_path__ + "static/media/Map_main.34721c21.svg";